export enum SessionActionTypes {
    START = 'session/START',
}

export interface SessionState {
    started: boolean
}
